export type Capture = "component" | "canvas" | "running" | "library";

export const STAGES = [
  {
    num: "01",
    title: "Describe what you want to make.",
    body: "AI-guided engineering notebooks turn a plain-language product intent into structured, reviewable requirements and a functional breakdown — the spine every later stage builds on.",
    panelTitle: "notebook · intent → requirements",
  },
  {
    num: "02",
    title: "Real parts, simulation-ready.",
    body: "Every component carries its full record — specification, interfaces, manufacturing source and unit cost, compliance flags — and a functional model. Pick a motor; you also picked its dynamics.",
    capture: "component" as const,
    panelTitle: "components library — BLDC X2216 · 880 KV",
  },
  {
    num: "03",
    title: "Compose the device as a system.",
    body: "Wire the parts into a co-simulation on the canvas — radio, flight controller, ESCs, motors, propellers, battery, airframe — each block a real functional model exchanging real signals.",
    capture: "canvas" as const,
    panelTitle: "system canvas — Drone · Containerized MIL",
  },
  {
    num: "04",
    title: "Isaac Sim closes the loop.",
    body: "The airframe block is NVIDIA Isaac Sim: per-rotor thrust and torque from the functional models drive a 6-DOF PhysX rigid body on the GPU, and pose, IMU and GPS stream back into the running system — scopes, 3D twin and all.",
    capture: "running" as const,
    panelTitle: "workshop / system — live run",
  },
  {
    num: "05",
    title: "Ship a build-ready package.",
    body: "Bill of materials, interfaces, costs and manufacturing data are already attached to every part — the same model that flew in simulation becomes the package that goes to production.",
    capture: "library" as const,
    panelTitle: "components library — catalogue",
  },
] as const;
